"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var settings_1 = require("./settings");
var eventbody_1 = require("./eventbody");
var diveSdk_1 = require("./diveSdk");
var event_1 = require("./event");
var logger_1 = require("./logger");
var logLevel_1 = require("./logLevel");
var utils_1 = require("./utils");
var CheckpointNode = /** @class */ (function () {
    function CheckpointNode(name, ignoreDowntime) {
        this._name = name;
        this._id = utils_1.default.uuidv4();
        this._timestamp = performance.now();
        this._ignoreDowntime = ignoreDowntime;
    }
    Object.defineProperty(CheckpointNode.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CheckpointNode.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    CheckpointNode.prototype.createStartEventBody = function () {
        return {
            name: this._name,
            id: this._id,
        };
    };
    CheckpointNode.prototype.createEndEventBody = function () {
        return {
            name: this._name,
            id: this._id,
            total_milliseconds: Math.round(this.calculateElapsedTime() * 100) / 100,
        };
    };
    CheckpointNode.prototype.subtractDowntime = function (downtime) {
        if (!this._ignoreDowntime)
            return;
        this._timestamp += downtime;
    };
    CheckpointNode.prototype.calculateElapsedTime = function () {
        return performance.now() - this._timestamp;
    };
    return CheckpointNode;
}());
var Checkpoint = /** @class */ (function () {
    function Checkpoint() {
        if (this instanceof Checkpoint) {
            throw new Error('A Checkpoint class cannot be instantiated.');
        }
    }
    Checkpoint.Start = function (name, ignoreDowntime) {
        if (ignoreDowntime === void 0) { ignoreDowntime = true; }
        var checkpointIndex = this._findCheckpointIndex(name);
        if (checkpointIndex > -1) {
            logger_1.default.getInstance().add("Checkpoints names are unique, you have to end the \"" + name + "\" checkpoint before starting a new one with the same name.", logLevel_1.default.WARNING);
            return null;
        }
        var checkpoint = new CheckpointNode(name, ignoreDowntime);
        this._checkpoints.push(checkpoint);
        return new event_1.default('checkpointStarted', checkpoint.createStartEventBody());
    };
    Checkpoint.End = function (name) {
        var checkpointIndex = this._findCheckpointIndex(name);
        if (checkpointIndex === -1) {
            logger_1.default.getInstance().add("WARNING: No checkpoint found with the name \"" + name + "\".", logLevel_1.default.WARNING);
            return null;
        }
        var checkpoint = this._checkpoints[checkpointIndex];
        this._checkpoints.splice(checkpointIndex, 1);
        var downtime = this._calculateDowntime();
        if (downtime) {
            checkpoint.subtractDowntime(downtime);
        }
        return new event_1.default('checkpointEnded', checkpoint.createEndEventBody());
    };
    Checkpoint.StartDowntime = function () {
        this._lastActivityTimestamp = performance.now();
    };
    Checkpoint.EndDowntime = function () {
        var downtime = this._calculateDowntime();
        if (!downtime)
            return;
        var sessionLifetime = settings_1.default.getInstance().get("session_lifetime_sec", 15 * 60);
        if (sessionLifetime != 0 && downtime > sessionLifetime) {
            utils_1.default.refreshClientSessionId(sessionLifetime);
            var total_seconds = Math.round((downtime / 1000) * 100) / 100;
            var eventBody = new eventbody_1.default({ total_seconds: total_seconds });
            diveSdk_1.default.getInstance().RecordEvent("appResumed", eventBody);
        }
        this._lastActivityTimestamp = null;
        this._checkpoints.forEach(function (checkpoint) {
            checkpoint.subtractDowntime(downtime);
        });
    };
    Checkpoint.EndViewedScreen = function () {
        var checkpointIndex = this._findCheckpointIndex("dive_screen_track");
        if (checkpointIndex === -1)
            return 0;
        var elapsed_milliseconds = 0;
        var screenCheckpoint = new CheckpointNode("dive_screen_track", true);
        if (checkpointIndex > -1) {
            elapsed_milliseconds = Math.round(this._checkpoints[checkpointIndex].calculateElapsedTime() * 100) / 100;
            this._checkpoints[checkpointIndex] = screenCheckpoint;
        }
        else {
            this._checkpoints.push(screenCheckpoint);
        }
        return elapsed_milliseconds;
    };
    Checkpoint.Reset = function () {
        this._checkpoints = [];
        this._lastActivityTimestamp = null;
    };
    Checkpoint._findCheckpointIndex = function (name) {
        return this._checkpoints.findIndex(function (checkpoint) { return checkpoint.name === name; });
    };
    Checkpoint._calculateDowntime = function () {
        if (!this._lastActivityTimestamp)
            return 0;
        return performance.now() - this._lastActivityTimestamp;
    };
    Checkpoint._lastActivityTimestamp = null;
    Checkpoint._checkpoints = [];
    return Checkpoint;
}());
exports.default = Checkpoint;
//# sourceMappingURL=checkpoint.js.map